import { render, staticRenderFns } from "./allScanlScanAreaInfoDialog.vue?vue&type=template&id=3c128d43&scoped=true"
import script from "./allScanlScanAreaInfoDialog.vue?vue&type=script&lang=js"
export * from "./allScanlScanAreaInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./allScanlScanAreaInfoDialog.vue?vue&type=style&index=0&id=3c128d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c128d43",
  null
  
)

export default component.exports